import { observable, action } from 'mobx';

import { CombatType } from '../../../lib/types';

import { onCombatChanged } from '../../../lib/dbCalls';

import { mapCombat } from '../../../utils/combatUtils';

class CombatLogModalStore {
  @observable
  combat!: CombatType;

  combatChangedRef: any = {};

  @action
  setCombat(combat: CombatType) {
    this.combat = combat;
    this.listenChanges();
  }

  listenChanges() {
    this.combatChangedRef = onCombatChanged(this.combat.id, this.onCombatChanged);
  }

  @action
  onCombatChanged = async (snapshot: any) => {
    const value = snapshot.val();
    Object.assign(this.combat, await mapCombat(value, null, null, true));
  };

  @action
  clear() {
    this.combatChangedRef.off('value', this.onCombatChanged);

    this.combat = null as any;
  }
}

export default new CombatLogModalStore();
